import { FC } from 'react';
import styles from './styles.module.css';
import logo from 'url:/public/images/logo-limbic-name.svg';

const Footer: FC = () => (
  <div className={styles.wrapper}>
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.title}>
          AI Software for Mental
          <br />
          Healthcare in the UK
        </div>
        <div className={styles.logoContainer}>
          <img src={logo} alt="Limbic Logo" className={styles.logo} />
          <span>&copy; Limbic Limited, All rights reserved.</span>
        </div>
        <div className={styles.navContainer}>
          <div className={styles.nav}>
            <address>
              <p>Kemp House 160 City Road</p>
              <p>London</p>
              <p>EC1V 2NX</p>
            </address>
          </div>
        </div>
      </div>
    </footer>
  </div>
);

export default Footer;
